import React from 'react'

// Shared Reset / Apply footer for any panel that uses the staged-state pattern.
// DEV-2980: the storefront's .fb-menu-foot ("Clear all" / "Apply").

export default function PanelFooter({ onReset, onApply, applyDisabled, resetLabel = 'Clear all', applyLabel = 'Apply' }) {
  return (
    <div className="fb-menu-foot">
      <button type="button" className="fb-menu-reset" onClick={onReset}>
        {resetLabel}
      </button>
      <button
        type="button"
        className="fb-menu-apply"
        onClick={onApply}
        disabled={applyDisabled}
      >
        {applyLabel}
      </button>
    </div>
  )
}
